<ion-app>
    <ion-menu
        side="start"
        type="overlay"
        class="menu-sanduiche"
        menu-id="menuSanduiche"
        content-id="main"
    >
        <ion-header class="head">
            <ion-toolbar class="ion-text-start" color="primary">
                <ion-title>Surf Clube Conecta</ion-title>
            </ion-toolbar>
        </ion-header>

        <ion-content class="app-back">
            <ion-list
                color="light"
                class="ion-no-margin ion-no-padding"
                class="list-padd"
            >
                <ng-container *ngFor="let item of menuPrincial">
                    <ion-menu-toggle
                        menu="menuSanduiche"
                        auto-hide="false"
                        *ngIf="getCondition(item.condition)"
                    >
                        <ion-item
                            [routerLink]="item.route"
                            *ngIf="!item.hidden"
                            [disabled]="item.disabled"
                            detail
                            (click)="closeMenu()"
                        >
                            <ion-icon
                                [src]="item.icon.src"
                                *ngIf="item.icon.src; else namedIcon"
                            ></ion-icon>
                            <ng-template #namedIcon>
                                <ion-icon
                                    [name]="item.icon.name"
                                    [class]="item.icon.class"
                                ></ion-icon>
                            </ng-template>
                            <ion-label>{{ item.label }}</ion-label>
                        </ion-item>
                    </ion-menu-toggle>
                </ng-container>

                <ion-menu-toggle menu="menuSanduiche" auto-hide="false">
                    <ion-item (click)="touchLogout()" detail>
                        <ion-icon
                            name="log-out-outline"
                            class="icon-logout"
                        ></ion-icon>
                        <ion-label>SAIR</ion-label>
                    </ion-item>
                </ion-menu-toggle>
            </ion-list>

            <!-- <p class="version">Versão {{modelLocator.version}}</p> -->
            <p class="version">
                Versão {{ versionApp }} {{ bundleVersion ? bundleVersion : "" }}
            </p>
            <p class="copyright">&copy; icons4u - we love marketing</p>

            <hr style="background: #f4f4f4" />
        </ion-content>
    </ion-menu>

    <ion-menu
        side="end"
        type="overlay"
        class="menu-usuario"
        menu-id="menuUsuario"
        content-id="main"
    >
        <ion-header class="head">
            <ion-toolbar class="ion-text-start" color="primary">
                <ion-title>{{ modelLocator.dadosLogin.nome }}</ion-title>
            </ion-toolbar>
        </ion-header>

        <ion-content>
            <ng-container *ngFor="let item of menuUsuario">
                <ion-menu-toggle
                    menu="menuUsuario"
                    auto-hide="false"
                    *ngIf="getCondition(item.condition)"
                >
                    <ion-item
                        [routerLink]="item.route"
                        *ngIf="!item.hidden"
                        [disabled]="item.disabled"
                        detail
                        (click)="closeMenu()"
                    >
                        <ion-icon
                            [src]="item.icon.src"
                            *ngIf="item.icon.src; else namedIcon"
                        ></ion-icon>
                        <ng-template #namedIcon>
                            <ion-icon
                                [name]="item.icon.name"
                                [class]="item.icon.class"
                            ></ion-icon>
                        </ng-template>
                        <ion-label>{{ item.label }}</ion-label>
                    </ion-item>
                </ion-menu-toggle>
            </ng-container>

            <ion-row class="ion-justify-content-center">
                <div class="box-pontos" *ngIf="modelLocator.menu.pontuacao">
                    <span class="tit">PONTOS</span>
                    <span class="pontos_usuario pt">{{
                        modelLocator.saldo.tcoins_saldo
                            ? modelLocator.saldo.tcoins_saldo
                            : 0
                    }}</span>
                    <span
                        class="tit-expirar"
                        *ngIf="modelLocator.pts_expirar !== 0"
                        >PONTOS A EXPIRAR:</span
                    >
                    <span
                        class="pontos_usuario pt"
                        *ngIf="modelLocator.pts_expirar !== 0"
                        >{{ modelLocator.pts_expirar }}</span
                    >
                </div>
            </ion-row>

            <!-- <ion-row class="ion-justify-content-center">
        <div class="box-tickets" *ngIf="modelLocator.menu.pontuacao">
          <span class="pontos_usuario pt">{{modelLocator.saldo.ticket_saldo ? modelLocator.saldo.ticket_saldo : 0}}</span>
          <img src="../assets/image/ticket_menu.png" alt="">
        </div>
      </ion-row>


      <ion-row class="area-badge" *ngIf="modelLocator.menu.classificacao">
        <ion-col>
          <img *ngIf="this.modelLocator.dadosLogin.classificacao"
            src="../assets/badges/{{this.modelLocator.dadosLogin.classificacao}}.png"
            alt="{{this.modelLocator.dadosLogin.classificacao}}">
        </ion-col>
      </ion-row> -->
        </ion-content>
    </ion-menu>

    <ion-router-outlet id="main"></ion-router-outlet>

    <!-- <ion-img class="balao_1 ion-hide-md-up" *ngIf="modelLocator.balao_1" (click)="tutorial(1)"
    src="../../assets/image/balao_1.png" alt="balao_1"></ion-img>

  <ion-img class="balao_2 ion-hide-md-up" *ngIf="modelLocator.balao_2" (click)="tutorial(2)"
    src="../../assets/image/balao_2.png" alt="balao_2"></ion-img>

  <ion-img class="balao_3 ion-hide-md-up" *ngIf="modelLocator.balao_3" (click)="tutorial(3)"
    src="../../assets/image/balao_3.png" alt="balao_3"></ion-img>

  <ion-img class="balao_4 ion-hide-md-up" *ngIf="modelLocator.balao_4" (click)="tutorial(4)"
    src="../../assets/image/balao_4.png" alt="balao_4"></ion-img>

  <ion-img class="balao_5 ion-hide-md-up" *ngIf="modelLocator.balao_5" (click)="tutorial(5)"
    src="../../assets/image/balao_5.png" alt="balao_5"></ion-img> -->

    <!-- Popup challenge -->
    <ion-img
        class="balao_1 popup_1 ion-hide-md-up"
        *ngIf="modelLocator.balao_1"
        (click)="tutorial(1)"
        src="../assets/image/popup_challenges/popup_1.png"
        alt="balao_1"
    ></ion-img>

    <ion-img
        class="balao_2 popup_2 ion-hide-md-up"
        *ngIf="modelLocator.balao_2"
        (click)="tutorial(2)"
        src="../assets/image/popup_challenges/popup_2.png"
        alt="balao_2"
    ></ion-img>

    <ion-img
        class="balao_2 popup_3 ion-hide-md-up"
        *ngIf="modelLocator.balao_3"
        (click)="tutorial(3)"
        src="../assets/image/popup_challenges/popup_3.png"
        alt="balao_3"
    ></ion-img>

    <ion-img
        class="balao_4 popup_4 ion-hide-md-up"
        *ngIf="modelLocator.balao_4"
        (click)="tutorial(4)"
        src="../assets/image/popup_challenges/popup_4.png"
        alt="balao_4"
    ></ion-img>
</ion-app>
